// store/slices/productSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../services/api";

export const fetchProductDetails = createAsyncThunk(
  "product/fetchProductDetails",
  async ({ categorySlug, brandSlug, productSlug }, { rejectWithValue }) => {
    try {
      const response = await api.getProductBySlug(categorySlug, brandSlug, productSlug);
      return response.data || response;
    } catch (err) {
      return rejectWithValue(err.message || "Failed to load product");
    }
  }
);

const initialState = {
  data: null,
  product: null,
  brand: null,
  category: null,
  variations: [],
  loading: false,
  error: null,
  selectedVariant: null,
};

const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    clearProductData: (state) => {
      Object.assign(state, initialState);
    },
    setSelectedVariant: (state, action) => {
      state.selectedVariant = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.product = action.payload || null;
        state.brand = action.payload?.brand || null;
        state.category = action.payload?.brand?.category || null;
        state.variations = action.payload?.variations || [];
        state.selectedVariant = null; // Don't auto-select
      })
      .addCase(fetchProductDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.data = null;
        state.product = null;
        state.brand = null;
        state.category = null;
        state.variations = [];
        state.selectedVariant = null;
      });
  },
});

export const { clearProductData, setSelectedVariant } = productSlice.actions;
export default productSlice.reducer;